(() => {
  const root = document.querySelector('[data-best-sellers-filter]');
  const grid = document.querySelector('[data-best-sellers-grid]');

  if (!root || !grid) return;

  const buttons = Array.from(root.querySelectorAll('[data-best-sellers-platform]'));
  const scroller = root.querySelector('[data-best-sellers-filter-scroller]');
  const cards = Array.from(grid.querySelectorAll(':scope > .svc-card'));
  const moreButton = document.querySelector('[data-best-sellers-more]');
  const resultsCount = root.querySelector('[data-best-sellers-results-count]');
  const initialLimit = Number.parseInt(grid.dataset.initialLimit, 10) || 12;
  const loadStep = Number.parseInt(grid.dataset.loadStep, 10) || 8;
  const allowedPlatforms = new Set(buttons.map((button) => button.dataset.bestSellersPlatform));
  let activePlatform = 'all';
  let visibleLimit = initialLimit;

  const getMatchingCards = () => {
    if (activePlatform === 'all') return cards;

    const activeButton = buttons.find(
      (button) => button.dataset.bestSellersPlatform === activePlatform
    );
    const cardClasses = activeButton?.dataset.bestSellersCardClass?.split('~') || [];
    return cards.filter((card) => cardClasses.includes(card.dataset.platform));
  };

  const updateUrl = () => {
    const url = new URL(window.location.href);

    if (activePlatform === 'all') {
      url.searchParams.delete('platform');
    } else {
      url.searchParams.set('platform', activePlatform);
    }

    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const scrollToFirstResult = () => {
    if (window.innerWidth > 767) return;

    const firstCard = getMatchingCards()[0];
    if (!firstCard) return;

    window.requestAnimationFrame(() => {
      const header = document.querySelector('.header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const filterHeight = root.getBoundingClientRect().height;
      const cardTop = firstCard.getBoundingClientRect().top + window.scrollY;
      const targetTop = Math.max(0, cardTop - headerBottom - filterHeight - 16);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: targetTop,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });
  };

  const render = ({ updateHistory = true } = {}) => {
    const matchingCards = getMatchingCards();
    const visibleCards = new Set(matchingCards.slice(0, visibleLimit));

    grid.classList.toggle('is-compact-results', [0, 1, 2, 3].includes(matchingCards.length));

    cards.forEach((card) => {
      card.hidden = !visibleCards.has(card);
    });

    buttons.forEach((button) => {
      const isActive = button.dataset.bestSellersPlatform === activePlatform;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    if (resultsCount) resultsCount.textContent = String(matchingCards.length);
    if (moreButton) moreButton.hidden = visibleLimit >= matchingCards.length;
    if (updateHistory) updateUrl();
  };

  buttons.forEach((button) => {
    const platform = button.dataset.bestSellersPlatform;
    const cardClasses = button.dataset.bestSellersCardClass?.split('~') || [];
    const count = platform === 'all'
      ? cards.length
      : cards.filter((card) => cardClasses.includes(card.dataset.platform)).length;
    const countElement = button.querySelector('[data-best-sellers-count]');

    if (countElement) countElement.textContent = String(count);
    if (platform !== 'all' && count === 0) button.hidden = true;

    button.addEventListener('click', () => {
      activePlatform = platform;
      visibleLimit = initialLimit;
      render();
      scrollToFirstResult();

      if (scroller && scroller.scrollWidth > scroller.clientWidth) {
        const targetLeft = button.offsetLeft - (scroller.clientWidth - button.offsetWidth) / 2;
        scroller.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    });
  });

  moreButton?.addEventListener('click', () => {
    visibleLimit += loadStep;
    render({ updateHistory: false });
  });

  const requestedPlatform = new URL(window.location.href).searchParams.get('platform');
  if (requestedPlatform && allowedPlatforms.has(requestedPlatform)) {
    const requestedButton = buttons.find(
      (button) => button.dataset.bestSellersPlatform === requestedPlatform && !button.hidden
    );
    if (requestedButton) activePlatform = requestedPlatform;
  }

  let frameId = 0;
  const syncStickyOffset = () => {
    if (window.innerWidth > 767) {
      root.style.removeProperty('--best-sellers-sticky-top');
      return;
    }

    const header = document.querySelector('.header');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    root.style.setProperty('--best-sellers-sticky-top', `${Math.round(headerBottom)}px`);
  };

  const scheduleStickyOffset = () => {
    window.cancelAnimationFrame(frameId);
    frameId = window.requestAnimationFrame(syncStickyOffset);
  };

  window.addEventListener('resize', scheduleStickyOffset, { passive: true });
  window.addEventListener('scroll', scheduleStickyOffset, { passive: true });

  syncStickyOffset();
  render({ updateHistory: false });
})();
